<template>
	<div id="container" style="    width: 100%;height:100%;		background-color: #f7f7f7;" @click="categoryPageClick">
		<a-spin :spinning="reloadSpinning">
			<div>
				<Font @setOffsetTop="setOffsetTop"></Font>
				<div :style="scrolldiv" @scroll="handleScroll" class="scrolldiv">
					<div class="catalog-article-detail" style="width:80%">
						<div class="detail">
							<div class="powerby">
								<img class="powerby-image"
									:src="!todayImg ? require('../../assets/title_logo.png') : todayImg" />
							</div>
							
				
								<div v-html="aiContent" ref="htmlContainer" @click.stop="aiContentClick($event)"></div>
								<div @click.stop="clickLinkArticle" id="linkArticle"
									:style='{display:linkArticle.display,top:linkArticle.top,"z-index":linkArticle.index}'
									class="linkArticle">
									<div @click.stop="clickLinkArticleItem(item)"
										style="display: flex;    align-items: center;" v-for="(item,index) in linkList"
										v-bind:key="index">
										<div class="linkItem">{{item.index}}、{{item.title}}

										</div>
										<img :src="linkSrc" style="width: 15px;height: 15px;" />
									</div>

								</div>


			
						</div>
					</div>
				</div>
			</div>
		</a-spin>

	</div>
</template>
<script>



import $ from 'jquery'

import Font from '../articleComponent/Font.vue'
import { toDoArticleRecord } from './js/index'
import { getLoginUserInfo } from '../../views/js/index'
import { useRouter } from 'vue-router';
import { guestArticle, readList } from '../articleComponent/js/index'
import { onMounted, watch, ref, onDeactivated, onActivated } from 'vue'
import store from '@/store';
import router from '@/router';
import { nextTick } from 'vue';

export default {
	name: 'weeklyArticleDetail2',
	components: { Font},

	setup() {
		watch(() => store.getters.fontSize, (val, oldVal) => {
			fontSize.value = val
			toGetResize(fontSize.value, oldVal, aiContent.value)
			
		})
		const $router = useRouter();
		watch(
			() => $router.currentRoute.value.query,
			(val,old) => {
				if ($router.currentRoute.value.path.indexOf('weeklyArticleDetail') > -1 && val && val.warticleId) {
					aiCategoryId.value =  val.warticleId
					if (store.getters.companyList && store.getters.company) {
						var result = store.getters.companyList.find(item => item.companyId == store.getters.company.companyId)
						if (result) {
							todayImg.value = result.todayImg
							toShowDetail()
						}
						else {
							toGetUserInfor()
						}
					}
					else {
						toGetUserInfor()
					}
				}
				//如果不是文章返回的到文章列表 重置数据
		
					
			
			})
		onDeactivated	(() => {
			

				toDoArticleRecord(aiCategoryId.value, 2)
			 
		
		})
		onActivated(() => {
  
			fontSize.value = store.getters.fontSize
			toGetResize(fontSize.value, 2, aiContent.value)

				if(aiContent.value==null||aiContent.value==''){
					if ($router.currentRoute.value.query.warticleId) {
					aiCategoryId.value = $router.currentRoute.value.query.warticleId
					if (store.getters.company) {
						todayImg.value = store.getters.company.todayImg

						toShowDetail()
					}
					else {
						toGetUserInfor()
					}
				}
				}

			 document.querySelector('.scrolldiv').scrollTop = scrollY.value
		})


		const toShowDetail = async () => {
			
			var height = document.getElementById('container').offsetHeight
			scrolldiv.value = { height: (height - 20) + 'px', overflow: 'auto' }
			reloadSpinning.value = true
		await guestArticle({ id: aiCategoryId.value }).then(async (res) => {
						aiContent.value = res.data.content
						reloadSpinning.value = false
						toDoArticleRecord(aiCategoryId.value, 0)
							nextTick(() => {

						if (aiCategoryId.value) {
							$('.ai-category a').removeAttr('href');
							// console.log($('.ai-category').html(),'outerHTMLxixi')
							// if($('.ai-category')[0])
							// aiContent.value=$('.ai-category')[0].outerHTML;
						}
						setOffsetTop()
					})
					})
				
		
				
			

		}
		const reloadSpinning = ref(false)

		const scrolldiv = ref('')


		const todayImg = ref('')

		const toGetUserInfor = () => {

			getLoginUserInfo().then((res) => {
				store.dispatch('companyList', res.data.sysClient.companyVos[0])
				toShowDetail()
			})
		}

		const scrollY = ref(0)
		const fontSize = ref('')
		const aiContent = ref('')


		const aiCategoryId = ref(null)

		const linkList = ref([])
		const aiContentClick = (event) => {
			console.log(event, 'event')
			if (event.target.className == 'quote') {
				var list = []

				var eLinkList = event.target.attributes['data-href'].value.split("==")
				var eTitleList = event.target.attributes['data-title'].value.split("==")
				var eIndexList = event.target.attributes['data-index'].value.split("==")
				for (var i in eLinkList) {
					list.push({
						title: eTitleList[i],
						href: eLinkList[i],
						index: eIndexList[i]
					})
				}
				console.log(list, 'linkList')
				linkList.value = list
				linkArticle.value = {
					'display': 'block',
					'top': event.target.offsetTop + 'px',
					'index': 0
				}
				nextTick(() => {

					linkArticle.value.top = (event.target.offsetTop - $('.linkArticle').height() - 27) + 'px'
					linkArticle.value.index = 10
					// 创建一个选择器查询对象，.in(this)确保查询在当前页面的上下文中进行，而不是全局的上下文
					// const query = uni.createSelectorQuery().in(this);
					// var  superThis = this 
					// // boundingClientRect 会返回元素的边界信息（如宽度、高度、位置等）
					// query.select('#linkArticle').boundingClientRect(rect => {

					// 	superThis.linkArticle.top=(e.detail.y-rect.height-27)+'px'
					// 	superThis.linkArticle.index=10
					// 	}).exec();

				})

			} else linkArticle.value.display = 'none'

		}
		const linkArticle = ref({

			display: 'block',
			top: '0px',
			index: -10


		})



		const clickLinkArticle = () => {
			return
		}
		const clickLinkArticleItem = (item) => {
			console.log(item, 'clickLinkArticleItem')
			linkArticle.value.display = 'none'
			router.push({ name: 'articleDetail', query: { articleId: item.href } })

		}
		const categoryPageClick = () => {
            console.log('categoryPageClick')
			linkArticle.value.display = 'none'
		}
		const toGetResize = (val, oldVal, htmlContent) => {
			if (val == oldVal) {
				aiContent.value = htmlContent;
			}
			htmlContent = htmlContent.replace(/font-size:\d{1,20}px/g, function (param) {
				var result = param.substring(param.indexOf(':') + 1, param.indexOf('p'))
				return 'font-size:' + (Number(result) + (val - oldVal) * 2) + 'px'
			})
			aiContent.value = htmlContent;
		}
		const offsetTop=ref(0)
		const collapsedList=ref([])
	
	
		const setOffsetTop=()=>{
			var element=document.getElementsByClassName('fontResize')

			offsetTop.value=element[0].clientHeight+'px'
		}
		return {
			setOffsetTop,
			offsetTop,



			

			toGetResize,
			linkArticle,
			clickLinkArticle,
			clickLinkArticleItem,

			linkList,


			aiContent,
			aiCategoryId,
			aiContentClick,
			linkSrc: 'https://enplus.oss-cn-guangzhou.aliyuncs.com/file/ea4d857a-0283-42db-b265-92658fc03803.png',
			categoryPageClick,
			fontSize,
			scrollY,

			toGetUserInfor,
			todayImg,


			scrolldiv,


			reloadSpinning,
		
		}
	},
	beforeRouteLeave(to, from, next) {
		if (to.path == '/INT'||to.path == '/main') {
			this.scrollY = 0
		}
		else
			//保存滚动条元素div的scrollTop值
			this.scrollY = document.querySelector('.scrolldiv').scrollTop
		next();
	},
}
</script>
<style lang="scss" scoped>
@import '../../assets/style.scss';

.ubutton-class {
	padding: 0 10px !important;
	border: none !important;
	cursor: pointer;

	.u-hairline-border::after {
		border: none !important;
	}
}

.introduce {
	color: #888e90;
	cursor: pointer;
	font-size: 15px;
	line-height: 22px;
	text-overflow: ellipsis;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 4;
	line-clamp: 4;
	-webkit-box-orient: vertical;
	padding: 0px 12px 0px 12px;
	text-align: justify;
}

.introduceSmall {
	font-size: 13px !important;
}

.introduceBig {
	font-size: 17px !important;
}

.inline-content {
	cursor: pointer;
}

.inline-content {
	a {
		color: rgba(0, 0, 0, 0.9);
	}


}

.inline-content:hover {
	a {
		color: #315efb !important;
	}

}
	.introduce:hover{
				color: #babcbc !important;

	}
.scrolldiv {
	justify-content: center;
	display: flex;
}

.catalog-article-detail {


	.home {
		margin-left: 24px;
		width: 48px;
		height: 48px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;

		.home-img {
			width: 48px;
			height: 48px;
		}
	}

	.detail {
		padding: 20px 20px 80px;
		font-size: 24px;

		position: relative;

		.powerby {


			.powerby-image {
				width: 100%;
			}
		}

	


		



	
	}
}


.linkArticle {
	display: none;
	background-color: white;

	position: absolute;
	color: #009DA6;
	left: 0;
	right: 0;
	margin: auto;

	width: 90%;
	padding: 10px 10px;
	border-radius: 10px;
	box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}


.linkItem {
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 15px;
	line-height: 30px;
	width: 95%;
	cursor: pointer
}

.linkItem:hover {
	color: #1890ff;
}





</style>
<style lang="less">
.ai-category {
	padding: 0px 32px 32px 32px;
	line-height: 36px !important;

	ul {
		list-style-type: disc;
		padding-left: 2em;
	}

	.quote {
		line-height: 12px !important;
	}

	ul ul {
		list-style-type: circle;
	}

	h2 {
		font-weight: bold;

		strong {
			font-weight: bold;
			color: #595959;
		}
	}


}
</style>
